import { useCallback, useEffect, useState } from "react";
import { postAccount } from "./accountApi";

// The logged in user's plan and AI credits, from the Subscribe servlet's status:
// undefined while asked, null when it couldn't be, else {signedin, subscription, credits,
// upgradepence}. Asked again whenever creditsChanged() is called (after an AI run, an
// upgrade or a top-up), so every button and the account menu show the same numbers.

const EVENT = 'tms-credits-changed';
export const creditsChanged = () => window.dispatchEvent(new Event(EVENT));

const useCredits = (enabled = true) => {
    const [status, setStatus] = useState(undefined);
    const load = useCallback(() => {
        postAccount('/subscription', {action:'status'}).then(setStatus).catch(() => setStatus(null));
    }, []);
    useEffect(() => {
        if (!enabled) return undefined;
        load();
        window.addEventListener(EVENT, load);
        return () => window.removeEventListener(EVENT, load);
    }, [enabled, load]);
    return status;
};

export default useCredits;
